<template>
  <div class="docUpload" data-qa="docupload-div-hiuff">
    <v-dialog
      v-model="config.enabled"
      :persistent="true"
      max-width="390"
      style="overflow: none !important;"
     data-qa="docupload-dialog-mrd9x7">
      <v-card min-width="370" data-qa="docupload-card-47umx">
        <v-flex data-qa="docupload-flex-12ianr">
          <v-toolbar :color="primaryColor" max-height="50px" data-qa="docupload-toolbar-accy">
            <p data-qa="docupload-p-pxef93">
              <font class="pl-0 pt-0 white--text title font-weight-thin">{{ config.modalTitle }}</font>
            </p>
            <v-spacer data-qa="docupload-spacer-u94fog"></v-spacer>
            <p data-qa="docupload-p-vr1op">
              <font class="pr-0 justify-end">
                <v-icon class="white--text" @click="onClose()" data-qa="docupload-icon-g9g69c">mdi-close</v-icon>
              </font>
            </p>
          </v-toolbar>
          <v-sheet color="#f4f1fa" elevation="0" data-qa="docupload-sheet-t9k6x">
            <!-- Address Proof Upload -->
            <v-layout v-if="isAddressDoc" class="px-4 pt-2 py-0" wrap data-qa="docupload-layout-y5cu2j">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="docupload-flex-661j7h">
                <dob-fileUpload
                  @docSeletedCheck="checkDocType($event)"
                  @deleteAddressDocSelected="isBrowserSelected"
                />
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="docupload-flex-qhttzp">
                <div class="pa-0 pl-8" data-qa="docupload-div-rrjs3">
                  <v-select
                    v-model="selectedDocType"
                    :items="documentCaterogy"
                    :color="primaryColor"
                    :label="$t('docUpload.documentType')"
                    class="docUpload--mandatory"
                   data-qa="docupload-select-warljg"></v-select>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="isAddressDoc" wrap class="py-1" data-qa="docupload-layout-piciwv">
              <v-flex xs2 sm2 md2 lg2 xl2 class="pt-0 text-center" data-qa="docupload-flex-vu0cvp">
                <v-icon :color="secondaryColor" small class="pl-3" data-qa="docupload-icon-vv7uoq">mdi-information-outline</v-icon>
              </v-flex>
              <v-flex xs10 sm10 md10 lg10 xl10 class="pt-0" data-qa="docupload-flex-279j9a">
                <font
                  class="caption font-weight-bold"
                  :color="fileUploadError ? fileUploadError : '#757575'"
                >{{ $t("personalSettings.fileUpload.info") }}</font>
                <br data-qa="docupload-br-hg8ixg" />
                <font
                  class="caption font-weight-bold"
                  :color="fileUploadError ? fileUploadError : '#757575'"
                >{{ $t('photoCapture.upload_info') }} {{ getMaxSizeWithUnit(image.maxFileSize) }}.</font>
              </v-flex>
            </v-layout>
            <!-- Profile Picture Upload -->
            <v-layout v-if="!isAddressDoc" class="py-2" data-qa="docupload-layout-dyz42l">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="docupload-flex-5mplda">
                <dob-photoUpload @deleteClippedImg="isBrowserSelected" />
              </v-flex>
            </v-layout>
          </v-sheet>
          <v-divider :color="primaryColor" style="margin-top:0px; margin-bottom: 0px" data-qa="docupload-divider-38gm8"></v-divider>
          <v-switch
            v-model="enableCamera"
            :color="primaryColor"
            :label="$t('docUpload.useCamera')"
            class="pl-3 pt-2 title dcoUpload--switchAction"
           data-qa="docupload-switch-lpl9e"></v-switch>
          <v-layout v-if="!isAddressDoc" wrap class="py-1" data-qa="docupload-layout-7m9ch">
            <v-flex xs1 sm1 md1 lg1 xl1 class="pt-0" data-qa="docupload-flex-d55wt">
              <v-icon :color="secondaryColor" small class="pl-3" data-qa="docupload-icon-2h8gz9">mdi-information-outline</v-icon>
            </v-flex>
            <v-flex xs10 sm10 md10 lg10 xl10 class="pt-0" data-qa="docupload-flex-u3aibm">
              <font
                class="caption font-weight-bold"
                :color="photoUploadError ? photoUploadError : '#757575'"
              >{{ $t("personalSettings.photoUpload.info") }}</font>
              <br data-qa="docupload-br-y8j9rh" />
              <font
                class="caption font-weight-bold"
                :color="photoUploadError ? photoUploadError : '#757575'"
              >{{ $t('photoCapture.upload_info') }} {{ getMaxSizeWithUnit(image.maxPhotoSize) }}.</font>
            </v-flex>
          </v-layout>

          <v-card-text data-qa="docupload-card-text-betbblp">
            <v-progress-linear
              v-if="enableCamera"
              :active="!image.isCameraReady && !isDcoClipper()"
              :color="secondaryColor"
              indeterminate
              height="8"
             data-qa="docupload-progress-linear-qjzmpr"></v-progress-linear>

            <dob-camera
              v-if="isDcoCamera() && enableCamera"
              @blobURL="recievedCameraImage($event)"
              @isCameraActive="isCameraActive($event)"
              :isCameraStopped="cameraState"
            ></dob-camera>

            <dob-clipper
              v-if="isDcoClipper() && image.isAcceptable && !image.clippedImage"
              @clippedImage="recievedClippedImage($event, config.type)"
              @savePhoto="onSave"
              :config="{ image: this.image.uploadedImage ? this.image.uploadedImage: this.image.browsedImage, isActive: image.isClipped }"
            ></dob-clipper>

            <v-avatar
              v-if="image.clippedImage"
              tile
              height="220"
              width="300"
              style="max-width:310;"
              class="photo-capture--border mb-1"
             data-qa="docupload-avatar-u63mzn">
              <img data-qa="docupload-img-bm1re5"  :src="image.clippedImage" />
            </v-avatar>
          </v-card-text>

          <v-divider
            v-if="(isDcoClipper() && image.isAcceptable) || browsedAddrDoc"
            :color="primaryColor"
            style="margin-top:0px; margin-bottom: 0px"
           data-qa="docupload-divider-c0r0c"></v-divider>
          <v-card-actions
            v-if="(isDcoClipper() && image.isAcceptable) || browsedAddrDoc"
            class="pa-2"
           data-qa="docupload-card-actions-q04nm">
            <v-spacer data-qa="docupload-spacer-k2zsed"></v-spacer>
            <v-btn
              @click="save"
              :color="secondaryColor"
              :disabled="isSaveDisabled()"
              outlined
              class="font-weight-light text-none py-2 px-4"
             data-qa="docupload-btn-i074j5">{{ $t("docUpload.save") }}</v-btn>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import event from '@/util/event'
import store from '@/core/store'
import '@/styles/docUpload.scss'

export default {
  name: 'DocUpload',
  components: {
    'dob-camera': () => import('@/components/DOB-Camera/Camera.vue'),
    'dob-clipper': () => import('@/components/DOB-Camera/Clipper.vue'),
    'dob-fileUpload': () => import('@/components/DOB-Form/FileUpload.vue'),
    'dob-photoUpload': () => import('@/components/DOB-Camera/PhotoUpload.vue')
  },
  data () {
    return {
      enableCamera: false,
      cameraState: undefined,
      showActions: false,
      uploadType: '',
      browserSelected: false,
      browsedAddrDoc: false,
      documentCaterogy: [],
      selectedDocType: '',
      imageFileTypes: ['.png', '.jpeg', '.jpg', '.PNG', '.JPEG', '.JPG'],
      imageTypeDoc: false,
      imgTypeFromCamera: 'image/jpeg',
      image: {
        maxFileSize: this.$appSettings.defaultConfigurations.maxUploadFileSize,
        maxPhotoSize: this.$appSettings.defaultConfigurations
          .maxUploadPhotoSize,
        height: this.$appSettings.defaultConfigurations
          .uploadCustomerPhotoHeight,
        width: this.$appSettings.defaultConfigurations.uploadCustomerPhotoWidth,
        isAcceptable: true,
        browsedImage: undefined,
        clippedImage: undefined,
        uploadedImage: undefined,
        isCameraReady: false,
        isClipped: false
      },
      doc: {
        clippedDoc: undefined,
        isClipped: false,
        uploadedDoc: undefined,
        browsedDoc: undefined
      },
      fileUploadError: '',
      photoUploadError: '',
      browsedFileName: '',
      isAddressDoc: this.config.type === 'residential' || this.config.type === 'correspondence'
    }
  },
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  created () {
    const types = JSON.parse(sessionStorage.getItem('documentTypes'))
    if (types) {
      types.forEach((type) => {
        this.documentCaterogy.push(type.documentType)
      })
    }
    event.$on('selectedPhoto', (arg) => {
      this.image.browsedImage = arg
    })
    event.$on('addressDocSelected', (arg) => {
      this.browsedAddrDoc = Boolean(arg)
      this.browsedFileName = arg.name
    })
    event.$on('isFileUploadError', (arg) => {
      this.fileUploadError = arg
    })
    event.$on('isPhotoUploadError', (arg) => {
      this.photoUploadError = arg
    })
  },
  methods: {
    getMaxSizeWithUnit (size) {
      if (size && !isNaN(size)) {
        if (size < 1000) {
          const verifiedKBSize = Number.isInteger(size) ? size : size.toFixed(1)
          return `${verifiedKBSize}KB`
        } else {
          const verifiedMBSize = Number.isInteger(size / 1000) ? (size / 1000) : (size / 1000).toFixed(1)
          return `${verifiedMBSize}MB`
        }
      }
    },
    inputChange (e) {
      const imageFile = this.$refs.upload.file
      // store image name for file reconstruction
      this.$store.dispatch('profileStore/setProfileData', { customerImageFileName: imageFile.name, customerImageFileType: imageFile.type })
    },
    isDcoCamera () {
      return !this.image.uploadedImage && !this.image.browsedImage
    },
    isDcoClipper () {
      return this.image.uploadedImage
        ? this.image.uploadedImage
        : this.image.browsedImage
    },
    checkDocType (data) {
      const fileExtension = data.docType.substr(data.docType.lastIndexOf('.'))
      if (this.imageFileTypes.includes(fileExtension)) {
        this.image.browsedImage = data.doc
        this.imageTypeDoc = true
      }
      this.uploadType = 'addressDoc'
      const { addressDoc = {} } = this.$store.getters['profileStore/profileData']
      Object.assign(addressDoc, { [this.config.type]: { data: data.doc, file: data.file, ...(this.selectedDocType && { docType: this.selectedDocType }) } })
      store.dispatch('profileStore/setProfileData', { addressDoc })
      // this.$emit('on-document-uploaded', data)
    },
    isCamera () {
      this.cameraState = false
      this.image.isClipped = false
      this.image.clippedImage = false
      this.image.uploadedImage = ''
      this.image.browsedImage = ''
      this.image.isCameraReady = false
      this.browserSelected = false
      this.browsedAddrDoc = false
      this.image.isAcceptable = true
    },
    isBrowserSelected () {
      this.browserSelected = false
      this.browsedAddrDoc = false
      this.imageTypeDoc = false
      this.image.browsedImage = undefined
      this.image.clippedImage = undefined
      this.image.isAcceptable = true
    },
    recievedCameraImage ({ image, stream, mimeType }) {
      this.image.uploadedImage = image
      this.image.isAcceptable = true
      this.imgTypeFromCamera = mimeType || 'image/jpeg'

      stream.getTracks().forEach((track) => {
        track.stop()
      })
    },
    recievedClippedImage (clippedImage, type) {
      if (type === 'customerDoc') {
        this.receivedCustomerClippedImage(clippedImage, type)
      }
      if (type === 'residential' || type === 'correspondence') {
        this.receivedAddressProofClippedImage(clippedImage, type)
      }
    },
    receivedCustomerClippedImage (clippedImage, type) {
      const fileExt = this.imgTypeFromCamera.substring(this.imgTypeFromCamera.lastIndexOf('/') + 1, this.imgTypeFromCamera.length)
      this.image.clippedImage = clippedImage.image
      this.$store.dispatch('profileStore/setProfileData', { [type]: clippedImage.blobUrl, clippedImageDataURL: clippedImage.image })
      const { customerImageFileName = `image.${fileExt}`, customerImageFileType = this.imgTypeFromCamera } = this.$store.getters['profileStore/profileData']
      const imageFile = this.dataURLtoFile(clippedImage.image, customerImageFileName, customerImageFileType)
      this.$store.dispatch('profileStore/setProfileData', { [`${type}ClippedFile`]: imageFile })
      this.uploadType = type
      this.image.isClipped = false
    },
    receivedAddressProofClippedImage (clippedImage, type) {
      this.image.clippedImage = clippedImage.image
      const { fileName, fileType } = this.$store.getters['profileStore/profileData']
      const imageFile = this.dataURLtoFile(clippedImage.image, fileName, fileType)
      const { addressDoc = {} } = store.getters['profileStore/profileData']
      Object.assign(addressDoc[type], {
        blobUrl: clippedImage.blobUrl,
        clippedImageDataURL: clippedImage.image,
        clippedFile: imageFile
      })
      store.dispatch('profileStore/setProfileData', { addressDoc })
      this.uploadType = type
      this.image.isClipped = false
    },
    dataURLtoFile (dataurl, filename, mimeType) {
      var arr = dataurl.split(',')
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mimeType })
    },
    deleteClippedImage () {
      this.image.clippedImage = false
    },
    isSaveDisabled () {
      const file = store.getters['profileStore/profileData'].file

      if (!(this.isAddressDoc)) {
        return !this.image.clippedImage
      } else {
        if (this.imageTypeDoc && this.image.browsedImage) {
          return !this.image.clippedImage || !this.selectedDocType
        }
        if (!this.imageTypeDoc && this.browsedAddrDoc) {
          return !file || !this.selectedDocType
        }
        if (!file && this.enableCamera && !this.image.browsedImage) {
          return !this.image.clippedImage || !this.selectedDocType
        }
      }
    },
    save () {
      event.$emit('docImageUploaded', this.uploadType)
      this.browserSelected = false
      this.$emit('close', true)
    },
    onSave () {
      this.image.isClipped = !this.image.isClipped
    },
    isCameraActive (state) {
      this.image.isCameraReady = state
    },
    onClose () {
      this.cameraState = true
      this.browserSelected = false
      event.$emit('stopCam', true)
      setTimeout(() => {
        this.$emit('close', true)
      }, 100)
    }
  },
  beforeDestroy () {
    event.$emit('stopCam', true)
    event.$off('addressDocSelected', false)
  },
  watch: {
    enableCamera (newValue) {
      this.doc = {
        clippedDoc: undefined,
        isClipped: false,
        uploadedDoc: undefined,
        browsedDoc: undefined,
        browserSelected: false
      }
      if (this.enableCamera) {
        this.isCamera()
        this.isBrowserSelected()
        event.$emit('removeFile', false)
      }
      if (!newValue) {
        event.$emit('stopCam', true)
      }
    },
    selectedDocType () {
      // adds docType property to addressDoc.residential or addressDoc.correspondence
      const { addressDoc } = store.getters['profileStore/profileData']
      if (addressDoc) {
        const { [this.config.type]: doc = {} } = addressDoc
        Object.assign(doc, { docType: this.selectedDocType })
        Object.assign(addressDoc, { [this.config.type]: doc })
        store.dispatch('profileStore/setProfileData', { addressDoc })
      }
    },
    browsedFileName (newValue) {
      // when file selection changes
      if (this.enableCamera || !newValue) {
        event.$emit('stopCam', true)
      }
      if (this.browsedAddrDoc) {
        this.enableCamera = false
      }
      if (newValue) {
        this.image.uploadedImage = ''
        this.image.clippedImage = ''
      }
      this.isSaveDisabled()
    }
  }
}
</script>
